/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_Tea_Lots_PlaceholderInputs */

const vi_product_classification_tea_lots_placeholder = /** @type {(inputs: Product_Classification_Tea_Lots_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô chè...`)
};

/**

* @param {Product_Classification_Tea_Lots_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_tea_lots_placeholder = /** @type {((inputs?: Product_Classification_Tea_Lots_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_Tea_Lots_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_tea_lots_placeholder(inputs)
});